import { Box, BoxProps } from '@mantine/core';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { gameAsideModel } from 'entities/game';
import { shiftModel } from 'entities/shift';
import { viewerModel } from 'entities/viewer';
import { gameRoute, shiftsRoute } from 'shared/routing';
import { NavList } from 'shared/ui';
import { cashierLayoutModel } from '../../model';
import cls from './cashier-layout-nav-list.module.scss';

export const CashierLayoutNavList = ({ ...props }: BoxProps) => {
	const { t } = useTranslation();

	const [shiftActive, openedGames, games, cashdesk] = useUnit([
		shiftModel.$shiftActive,
		cashierLayoutModel.$openedGames,
		gameAsideModel.$games,
		viewerModel.$cashdesk,
	]);

	return (
		<Box
			className={cls.cashierLayoutNavList}
			component='nav'
			{...props}
		>
			<NavList.Item
				data-test-id='cashier-layout-shifts'
				to={shiftsRoute}
			>
				{t('cashier-layout.shifts')}
			</NavList.Item>
			<NavList.Item
				data-test-id='cashier-layout-games'
				disabled={!shiftActive || cashdesk === null}
				to={gameRoute}
				query={games[0] ? { id: games[0].id } : undefined}
				active={openedGames}
			>
				{t('cashier-layout.games')}
			</NavList.Item>
		</Box>
	);
};
